import React from 'react';
import SoltItem from './SlotItem';

const OfficeSlot = (props) => {
  return (
    <div className="officeBookSoltItem">
      <div className="officeBookSoltTitle">{props.title}</div>
      <div className="officeBookSoltInner">
        {props.data.map((d, index) => (
          <>
            <SoltItem time={d.title} OnClick={props.OnClick} className={d.className} tooltip={d.tooltip} />
          </>
        ))}
      </div>
    </div>
  );
};
export default OfficeSlot;
